import { useState, useEffect } from "react";
import {
  getSubscriptionList,
  cancelSubscriptionData,
  extendSubscriptionData,
} from "../../../../services/admin/adminServices";
import toast from "../../../../utils/toast";

export default function Subscription() {
  const [isSubscriptionList, setSubscriptionList] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(true);
  const [cancelModal, setCancelModal] = useState({ open: false, id: null });
  const [cancelRemark, setCancelRemark] = useState("");
  const [cancelLoading, setCancelLoading] = useState(false);

  const [extendModal, setExtendModal] = useState({ open: false, id: null });
  const [extendForm, setExtendForm] = useState({ extendDays: "", remark: "" });
  const [extendLoading, setExtendLoading] = useState(false);

  const [filters, setFilters] = useState({
    OwnerId: "",
    IsActive: "",
    Page: 1,
    PageSize: 20,
  });

  useEffect(() => {
    fetchSubscriptions();
  }, [filters]);

  const fetchSubscriptions = async () => {
    setListLoading(true);
    try {
      const params = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== ""),
      );

      const res = await getSubscriptionList(params);
      if (res.statusCode === 1) {
        setSubscriptionList(res?.data.items);
        setTotalCount(res?.data.totalCount);
        setTotalPages(res?.data.totalPages);
      }
    } catch (err) {
      console.log(
        err.response?.data?.message || "Failed to fetch subscriptions",
      );
    } finally {
      setListLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
      Page: 1,
    }));
  };

  const handlePageChange = (page) => {
    setFilters((prev) => ({ ...prev, Page: page }));
  };

  const handleCancel = async () => {
    if (!cancelRemark.trim()) {
      toast.error("Remark is required.");
      return;
    }
    setCancelLoading(true);
    try {
      const res = await cancelSubscriptionData(cancelModal.id, {
        remark: cancelRemark,
      });
      if (res.statusCode === 1) {
        toast.success(res.message);
        setCancelModal({ open: false, id: null });
        setCancelRemark("");
        fetchSubscriptions();
      } else toast.error(res.message);
    } catch {
      toast.error("Failed to cancel.");
    } finally {
      setCancelLoading(false);
    }
  };

  const handleExtend = async () => {
    if (!extendForm.extendDays) {
      toast.error("Extend days is required.");
      return;
    }
    if (!extendForm.remark.trim()) {
      toast.error("Remark is required.");
      return;
    }
    setExtendLoading(true);
    try {
      const res = await extendSubscriptionData(extendModal.id, {
        extendDays: Number(extendForm.extendDays),
        remark: extendForm.remark,
      });
      if (res.statusCode === 1) {
        toast.success(res.message);
        setExtendModal({ open: false, id: null });
        setExtendForm({ extendDays: "", remark: "" });
        fetchSubscriptions();
      } else toast.error(res.message);
    } catch {
      toast.error("Failed to extend.");
    } finally {
      setExtendLoading(false);
    }
  };

  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              sa-subscriptions
            </div>
            <div className="page-sub" id="page-sub" />
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="stat-grid">
            <div className="stat-card">
              <div className="stat-icon">💳</div>
              <div className="stat-label">Total Subscriptions</div>
              <div className="stat-value">{totalCount}</div>
              <div className="stat-delta delta-up">Active</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🆕</div>
              <div className="stat-label">New This Month</div>
              <div className="stat-value">6</div>
              <div className="stat-delta delta-up">Fresh</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🔄</div>
              <div className="stat-label">Renewals</div>
              <div className="stat-value">22</div>
              <div className="stat-delta delta-up">Retention: 88%</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">❌</div>
              <div className="stat-label">Churned</div>
              <div className="stat-value">3</div>
              <div className="stat-delta delta-dn">Left</div>
            </div>
          </div>
          <div className="card">
            <div className="card-title">All Subscriptions</div>

            {/* ── Filter Bar ── */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 14,
                flexWrap: "wrap",
                gap: 10,
              }}
            >
              <div className="flex-gap8" style={{ flexWrap: "wrap" }}>
                <input
                  type="text"
                  name="OwnerId"
                  value={filters.OwnerId}
                  onChange={handleFilterChange}
                  placeholder="🔍 Search by Owner ID"
                  style={{ fontSize: 12, padding: "6px 10px", width: 180 }}
                />

                <select
                  name="IsActive"
                  value={filters.IsActive}
                  onChange={handleFilterChange}
                  style={{ fontSize: 12, padding: "5px 8px", width: "auto" }}
                >
                  <option value="">All Status</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>

                {/* Reset button */}
                {(filters.OwnerId || filters.IsActive) && (
                  <button
                    className="btn btn-lg "
                    style={{ background: "#185fa5", color: "#fff" }}
                    onClick={() =>
                      setFilters({
                        OwnerId: "",
                        IsActive: "",
                        Page: 1,
                        PageSize: 20,
                      })
                    }
                  >
                    Reset
                  </button>
                )}
              </div>
            </div>

            <div style={{ overflowX: "auto" }}>
              <table>
                <thead>
                  <tr>
                    <th>S.N.</th>
                    <th>User</th>
                    <th>Plan</th>
                    <th>Plan Type</th>
                    <th>Amount</th>
                    <th>Start</th>
                    <th>Expiry</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {listLoading ? (
                    Array.from({ length: 8 }).map((_, i) => (
                      <tr key={i}>
                        {Array.from({ length: 9 }).map((_, j) => (
                          <td key={j}>
                            <div
                              style={{
                                height: 14,
                                borderRadius: 6,
                                background:
                                  "linear-gradient(90deg, var(--bg-secondary) 25%, var(--border-light) 50%, var(--bg-secondary) 75%)",
                                backgroundSize: "200% 100%",
                                animation: "shimmer 1.4s infinite",
                                width:
                                  j === 1 ? "80%" : j === 8 ? "60%" : "70%",
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : isSubscriptionList?.length === 0 ? (
                    <tr>
                      <td
                        colSpan={9}
                        style={{
                          textAlign: "center",
                          color: "var(--text-tertiary)",
                          padding: 24,
                        }}
                      >
                        No subscriptions found.
                      </td>
                    </tr>
                  ) : (
                    isSubscriptionList?.map((sub, index) => (
                      <tr key={sub.subscriptionId}>
                        <td className="sn-col">
                          {(filters.Page - 1) * filters.PageSize + index + 1}
                        </td>
                        <td>
                          <div style={{ fontWeight: 500 }}>
                            {sub?.ownerName || "—"}
                          </div>
                          <div
                            style={{
                              fontSize: 11,
                              color: "var(--text-tertiary)",
                            }}
                          >
                            [{sub?.ownerId || ""}]
                          </div>
                        </td>
                        <td>
                          <div>{sub?.packageName || "—"}</div>
                        </td>
                        <td> {sub?.planType || ""}</td>
                        <td>₹ {sub?.amount?.toLocaleString("en-IN")}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {sub?.startDate
                            ? new Date(sub?.startDate).toLocaleDateString(
                                "en-IN",
                                { day: "2-digit", month: "short" },
                              )
                            : "—"}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {sub?.endDate
                            ? new Date(sub?.endDate).toLocaleDateString(
                                "en-IN",
                                { day: "2-digit", month: "short" },
                              )
                            : "—"}
                        </td>
                        <td>
                          <span
                            className={`badge ${sub?.isActive ? "badge-active" : "badge-inactive"}`}
                          >
                            {sub?.isActive ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td>
                          <div className="td-actions">
                            <span
                              className="action-icon"
                              title="Extend"
                              onClick={() => {
                                setExtendModal({
                                  open: true,
                                  id: sub.subscriptionId,
                                });
                                setExtendForm({ extendDays: "", remark: "" });
                              }}
                            >
                              +
                            </span>
                            {sub?.isActive && (
                              <span
                                className="action-icon red"
                                title="Cancel"
                                onClick={() => {
                                  setCancelModal({
                                    open: true,
                                    id: sub.subscriptionId,
                                  });
                                  setCancelRemark("");
                                }}
                              >
                                ✕
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div
              style={{
                marginTop: 12,
                display: "flex",
                justifyContent: "space-between",
                fontSize: 12,
                color: "var(--text-secondary)",
              }}
            >
              {/* ── Left side — pagesize + count ── */}
              <div className="flex-gap8" style={{ alignItems: "center" }}>
                <select
                  name="PageSize"
                  value={filters.PageSize}
                  onChange={handleFilterChange}
                  style={{ fontSize: 10, padding: "4px 8px", width: "auto" }}
                >
                  <option value={10}>10 / page</option>
                  <option value={20}>20 / page</option>
                  <option value={50}>50 / page</option>
                </select>

                <span>
                  Showing
                  <strong>
                    &nbsp;{isSubscriptionList?.length} Subscription
                  </strong>
                </span>
              </div>

              {/* ── Right side — prev / pages / next ── */}
              <div className="flex-gap8">
                <button
                  className="btn btn-xs"
                  disabled={filters.Page === 1}
                  onClick={() => handlePageChange(filters.Page - 1)}
                >
                  ‹ Prev
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (page) => (
                    <span
                      key={page}
                      onClick={() => handlePageChange(page)}
                      style={{
                        padding: "2px 8px",
                        background:
                          filters.Page === page ? "var(--blue)" : "transparent",
                        color:
                          filters.Page === page
                            ? "#fff"
                            : "var(--text-secondary)",
                        borderRadius: 5,
                        fontSize: 11,
                        cursor: "pointer",
                        border:
                          filters.Page === page
                            ? "none"
                            : "1px solid var(--border-mid)",
                      }}
                    >
                      {page}
                    </span>
                  ),
                )}

                <button
                  className="btn btn-xs"
                  disabled={filters.Page === totalPages}
                  onClick={() => handlePageChange(filters.Page + 1)}
                >
                  Next ›
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ── Cancel Modal ── */}
        {cancelModal.open && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 420, maxWidth: "98vw" }}>
              <div className="modal-header">
                <div className="modal-title">Cancel Subscription</div>
                <button
                  className="modal-close"
                  onClick={() => setCancelModal({ open: false, id: null })}
                >
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div
                  style={{
                    fontSize: 13,
                    color: "var(--text-secondary)",
                    marginBottom: 14,
                  }}
                >
                  Are you sure you want to cancel this subscription? Please
                  provide a reason.
                </div>
                <div className="form-group">
                  <label>Remark *</label>
                  <textarea
                    value={cancelRemark}
                    onChange={(e) => setCancelRemark(e.target.value)}
                    rows={3}
                    placeholder="Enter reason for cancellation..."
                    style={{
                      width: "100%",
                      fontFamily: "inherit",
                      fontSize: 13,
                      resize: "vertical",
                    }}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={() => setCancelModal({ open: false, id: null })}
                >
                  Cancel
                </button>
                <button
                  className="btn"
                  style={{
                    background: "var(--red, #dc2626)",
                    color: "#fff",
                    border: "none",
                  }}
                  onClick={handleCancel}
                  disabled={cancelLoading}
                >
                  {cancelLoading ? "Cancelling..." : "✕ Yes, Cancel"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Extend Modal ── */}
        {extendModal.open && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 420, maxWidth: "98vw" }}>
              <div className="modal-header">
                <div className="modal-title">Extend Subscription</div>
                <button
                  className="modal-close"
                  onClick={() => setExtendModal({ open: false, id: null })}
                >
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group mb12">
                  <label>Extend Days *</label>
                  <input
                    type="number"
                    min={1}
                    value={extendForm.extendDays}
                    onChange={(e) =>
                      setExtendForm((p) => ({
                        ...p,
                        extendDays: e.target.value,
                      }))
                    }
                    placeholder="e.g. 30"
                  />
                </div>
                <div className="form-group">
                  <label>Remark *</label>
                  <textarea
                    value={extendForm.remark}
                    onChange={(e) =>
                      setExtendForm((p) => ({ ...p, remark: e.target.value }))
                    }
                    rows={3}
                    placeholder="Enter reason for extension..."
                    style={{
                      width: "100%",
                      fontFamily: "inherit",
                      fontSize: 13,
                      resize: "vertical",
                    }}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={() => setExtendModal({ open: false, id: null })}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleExtend}
                  disabled={extendLoading}
                >
                  {extendLoading ? "Extending..." : "+ Extend Subscription"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
